module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'selfStyle': _vm.selfStyle
    },
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "part1"
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": "/Contact"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact')))]), _c('span', {
    staticClass: "line"
  })], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/Resource"
    }
  }, [_vm._v(_vm._s(_vm.$t('resources')))]), _c('span', {
    staticClass: "line"
  })], 1), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.openapiHref,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('openapi')))])])]), _vm._v(" "), _c('div', {
    staticClass: "copyright-for-phone"
  }, [_vm._v("Copyright © Crait Corp. All Rights Reserved.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © Crait Corp. All Rights Reserved.")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "follow-us"
  }, [_c('span', [_vm._v("Follow us")]), _vm._v(" "), _c('a', {
    staticClass: "facebook cur",
    attrs: {
      "href": "https://www.facebook.com/craitapp/",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twitter cur",
    attrs: {
      "href": "https://twitter.com/craitapp?lang=e",
      "target": "_blank"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-451fbe4b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 295
// module chunks = 1